import {
    AnimationBaseController,
    IAnimationControllerConfiguration, Inject
} from '@denishussar/html5-game-engine';
import { Sprite, Texture } from 'pixi.js';
import { AnimationContents } from '../../../../AnimationContents';
import { WhiteTextWithVioletStrokeStyle, YellowTextStyle } from '../../../Constants/TextStyles';
import { GameLogic } from '../../../Logic/GameLogic';
import { AlbumsLibrary } from '../../../Models/AlbumsLibrary';
import { GameModel } from '../../../Models/GameModel';
import { IAlbumData, IPictureData } from '../../../Services/CloudDB/Contract';
import {getSpriteFromUrl} from "../../../Common/getSpriteFromUrl";
import {createGreyTexture, createPixelizeTexture} from "../../../Common/Utils";
import {ButtonController, IButtonControllerOptions} from "../../../Common/ButtonController";
import {GameEvent, GameEventSceneButtonClick} from "../../../Constants/GameEvent";
import { FREE_IMAGES_LIST } from '../../../Constants/FreeImages';

export interface ICatalogIconControllerOptions {
    onClick: (pictureId: string) => void;
    album: IAlbumData;
    picture: IPictureData;
    texture: Texture;
}

export class CatalogIconController extends AnimationBaseController {
    $model: GameModel;

    spinner: Sprite;

    public constructor(
        @Inject private _options: ICatalogIconControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('CatalogIconController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CATALOG_JSON,
            libraryName: 'albums_icon',
            childControllers: {
            },
            onTap: () => {
                this._options.onClick(this._options.picture.id);
            },
        };
    }

    protected onInitialize() {
        this.display.alpha = 0;
        this.setTextStyleByQuery('txt_size', WhiteTextWithVioletStrokeStyle);
        this.setTextStyleByQuery('txt_price', YellowTextStyle);
        this.setTextStyleByQuery('txt_price', YellowTextStyle);
        this.setTextStyleByQuery('txt_progress', YellowTextStyle);

        // const spinnerTexture = this.resourcesLoader.loader.resources['spinner'].texture ?? null;
        // this.spinner = new Sprite(spinnerTexture);
        // this.spinner.interactive = false;
        // this.spinner.anchor.set(0.5);
        // this.spinner.scale.set(0.4)
        // this.display.addChild(this.spinner);

        const icon = this.getDisplayObjectByQuery('icon_picture_journal')[0];
        const texture = this._options.texture;
        const save = this._gameLogic.getSave(this._options.picture.id);

        const sprite = new Sprite();
        sprite.texture = texture;
        if (!save) {
            getSpriteFromUrl('assets/' + this._options.picture.src.replace(".png", "_preview.png"), `icon${this._options.picture.id}_preview`)
                .then((res) => {
                    const {sprite: localSprite, cached} = res;
                    let texture: PIXI.Texture | undefined = localSprite.texture;
                    // console.log(texture)
                    if (localSprite.texture) {
                        texture = createPixelizeTexture(localSprite.texture);
                        texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                    }

                    sprite.texture = texture;
                });
        }

        sprite.anchor.set(sprite.anchor.x, -(sprite.width - sprite.height) / sprite.width);
        sprite.width = !!save ? 290 : 306;
        sprite.height = !!save ? 290 : 306;
        sprite.anchor.set(0.5);
        sprite.x = icon.x;
        sprite.y = icon.y;

        const freepictures = FREE_IMAGES_LIST;

        const percent = save ? this._gameLogic.getPercentageProgress(save) : 0;
        if (!save && percent === 0 && this._options.album && (this._options.album.id === AlbumsLibrary.MY_COLLECTION || !!~freepictures.indexOf(this._options.picture.id))) {
            this.gotoAndStop('idle'); // add || progress
            this.display.addChildAt(sprite, this.display.children.length - 3);
        } else if (save) {
            this.gotoAndStop('progress');
            this.setTextByQuery('txt_progress', `${percent}%`);
            this.display.addChild(sprite);
        } else {
            this.gotoAndStop(this._gameLogic.balanceManager.isPictureRewardAvaliable(texture.width) ?  'add' : 'coins'); // idle || progress
            this.display.addChildAt(sprite, this.display.children.length - 3);
        }

        this.gotoAndStopByQuery("tag",'empty')

        if (!!~AnimationContents.CATALOG_TAGS_LIST['hot']?.indexOf(this._options.picture.id)) {
            this.gotoAndStopByQuery("tag",'hot');
        }
        if (!!~AnimationContents.CATALOG_TAGS_LIST['new']?.indexOf(this._options.picture.id)) {
            this.gotoAndStopByQuery("tag",'new');
        }

        this.setTextByQuery('txt_size', `${sprite.texture.width}x${sprite.texture.height}`);
        this.setTextByQuery('txt_price', `${this._gameLogic.balanceManager.getPicturePrice(sprite.texture.width)}`);

        // this.spinner.visible = false;
    }

    protected onUpdate(frameRate: number) {
        if (this.spinner && this.spinner.visible) {
            this.spinner.rotation += 10 * frameRate;
        }
    }
}
